import React, { Component } from "react";
import Functions from "../../src/functions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

class Datetime extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    this.editable = this.editable.bind(this);
    this.nonEditable = this.nonEditable.bind(this);
    this.customUI = this.customUI.bind(this);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = this.props.value;
    console.log(defaultValue);

    let configuration = {
      dateFormat: this.props.property.toDateFormat,
    };

    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    if (this.props.property.configuration) {
      Object.keys(this.props.property.configuration).forEach((itm, idx) => {
        configuration[itm] = this.props.property.configuration[itm];
      });
    }

    this.state = {
      value: defaultValue ? new Date(defaultValue) : null,
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
      configuration: configuration,
    };
  }

  componentDidMount() {
    this.setState({
      format: this.props.property.fromDateFormat,
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      loaded: true,
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  onChange = (e) => {
    this.setState({ value: e });
    if (this.props.property.events) {
      if (this.props.property.events.onChange) {
        this.props.property.events.onChange({ object: this, value: e });
      }
    }
  };

  onChange = (e) => {
    this.setState({ value: e });
    if (this.props.property.events) {
      if (this.props.property.events.onChange) {
        this.props.property.events.onChange({ object: this, value: e });
      }
    }
  };

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  editable() {
    let control = (
      <React.Fragment>
        <DatePicker
          {...this.state.attributes}
          {...this.state.events}
          defaultValue={this.state.value}
          selected={this.state.value}
          {...this.state.configuration}
          onChange={this.onChange.bind(this)}
        />
        <input
          type="hidden"
          name={this.state.name}
          value={moment.utc(this.state.value).format()}
        ></input>
      </React.Fragment>
    );

    return this.customUI(control);
  }

  nonEditable() {
    let control = moment(this.state.defaultValue).isValid()
      ? moment(this.state.defaultValue).format(
          this.state.configuration.toDateFormat
            ? this.state.configuration.toDateFormat
            : "DD/MM/YYYY HH:mm:ss"
        )
      : this.state.defaultValue;

    // return this.state.configuration.dateFormat;
    return this.customUI(control);
  }

  render() {
    if (this.state.loaded) {
      let control = this.state.editable ? this.editable() : this.nonEditable();

      return control;
    }
    return "";
  }
}

export default Datetime;
